import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { AuthState } from './auth.state';

export const initialState: AuthState = {
  loggedInUser: undefined,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.setLoggedInUser, (state, { loggedInUser }) => ({
    ...state,
    loggedInUser,
  })),
);
